var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#0090ff;}.a{opacity:0;}.b,.e{fill:#0073c8;}.c,.i{fill:#3eaaf3;}.d,.e,.h,.i{fill-rule:evenodd;}.f,.h{fill:#323232;}.g{fill:#5dbeff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 120,
    height: 120,
    transform: "translate(-10 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95,0a5,5,0,0,1,5,5V62H0V5A5,5,0,0,1,5,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29,
    height: 5,
    transform: "translate(55 85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,62H100v6a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M27,73H56l-2.168,7.949A3.343,3.343,0,0,0,56,85H27a3.343,3.343,0,0,1-2.168-4.051L27,73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 20,
    height: 20,
    rx: 3,
    transform: "translate(14 10)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66 34)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M10,0A10,10,0,0,1,20,10H10Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M52,49v2H44V49Zm7-5v2H44V44Zm0-5v2H44V39Zm0-5v2H44V34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M48,20v2H44V20Zm0-5v2H44V15Zm0-5v2H44V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M71,20v2H51V20Zm15-5v2H51V15Zm0-5v2H51V10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.603ce17424e207cca885d4403a4acf9d.svg";
export { ForwardRef as ReactComponent };